<template>

  <v-row dense>
    <v-col cols="1">
      <v-text-field
        v-model="actionQuantity"
        outlined
        dense
        hide-details
        label="*Dosagem"
        type="number"
        background-color="white"
        :disabled="disabled"
      />
    </v-col>

    <v-col cols="3">
      <v-combobox
        v-model="actionUnity"
        outlined
        dense
        label="Descrição da dosagem"
        :hide-details="errors.actionUnity === undefined"
        :error-messages="errors.actionUnity"
        :items="actionUnities"
        :item-text="(item) => `${item.action} ${actionQuantity} ${item.unity}`"
        :search-input.sync="selectedActionUnity"
        background-color="FFF"
        :disabled="true"
      />
    </v-col>

    <v-col>
      <v-combobox
        v-model="frequency"
        outlined
        dense
        label="*Repetição da dose"
        :items="prescriptionFrequencies"
        item-text="name"
        :hide-details="errors.frequency === undefined"
        :error-messages="errors.frequency"
        background-color="white"
        :disabled="disabled"
      />
    </v-col>


    <v-col>
      <v-combobox
        v-model="howLong"
        outlined
        dense
        label="*Tempo de utilização"
        :items="prescriptionHowLongs"
        item-text="name"
        :hide-details="errors.howLong === undefined"
        :error-messages="errors.howLong"
        background-color="white"
        required
        :disabled="disabled"
      />
    </v-col>

    <v-col>
      <v-combobox
        v-model="period"
        outlined
        dense
        clearable
        label="Preferência de uso"
        :items="prescriptionPeriods"
        item-text="name"
        :hide-details="errors.period === undefined"
        :error-messages="errors.period"
        background-color="white"
        :disabled="disabled"
      />
    </v-col>

    <v-col cols="auto">

    <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon  @click="savePrescriptionItemAction" color="light-blue" :disabled="disabled"
            :attrs="attrs"
            v-on="on" >
                  <v-icon v-if="prescriptionItemAction.id !== ''">eva-edit-2-outline</v-icon>
                  <v-icon v-else>eva-edit-2-outline</v-icon>
            </v-btn>
          </template>
          <span> adicionar posologia ao medicamento</span>
        </v-tooltip>


      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            icon
            :attrs="attrs"
            v-on="on"
            v-if="prescriptionItemAction.id !== ''"
            @click="deletePrescriptionItemAction"
            :disabled="disabled"
          >
            <v-icon>eva-trash-outline</v-icon>
          </v-btn>
        </template>

        <span>
          Excluir
        </span>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script>
  import SAVE_PRESCRIPTION_ITEM_ACTION from "@/graphql/prescription/save_prescription_item_action.gql";
  import DELETE_PRESCRIPTION_ITEM_ACTION from "@/graphql/prescription/delete_prescription_item_action.gql";

  export default {
    name: "PrescriptionFormItemAction",
    props: {
      actionUnities: Array,
      prescriptionItemId: String,
      prescriptionItemAction: {
        type: Object,
        default: () => {
          return {
            id: "",
          };
        },
      },
      refreshList: Function,
      prescriptionFrequencies: Array,
      prescriptionPeriods: Array,
      prescriptionHowLongs: Array,
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        errors: {},
        prescriptionItemActionId: "",
        actionQuantity: 1,
        actionUnity: "",
        frequency: "",
        period: "",
        howLong: "",
      };
    },
    created() {
      this.loadAction();
    },
    watch: {
      actionUnities() {
        this.actionUnity = this.lodash.first(this.actionUnities);

        if (this.actionUnity) {
          this.actionQuantity = this.actionUnity.defaultQuantity;
        }
      },
    },
    computed: {
      selectedActionUnity: {
        set() {
          "";
        },
        get() {
          if (this.actionUnity) {
            return `${this.actionUnity.action} ${this.actionQuantity} ${this.actionUnity.unity}`;
          }

          return "";
        },
      },
    },
    methods: {
      loadAction() {
        this.prescriptionItemActionId = "";
        this.actionQuantity = 1;
        this.actionUnity = this.lodash.first(this.actionUnities);
        this.frequency = "";
        this.period = "";
        this.howLong = "";

        if (this.prescriptionItemAction.id !== "") {
          this.prescriptionItemActionId = this.prescriptionItemAction.id;

          this.actionQuantity = this.prescriptionItemAction.presentationActionQuantity;
          this.actionUnity = this.lodash.find(this.actionUnities, {
            id: this.prescriptionItemAction.presentationAction.id,
          });

          this.frequency = this.lodash.find(this.prescriptionFrequencies, {
            id: this.prescriptionItemAction.frequency.id,
          });

          if (this.prescriptionItemAction.period) {
            this.period = this.lodash.find(this.prescriptionPeriods, {
              id: this.prescriptionItemAction.period.id,
            });
          }

          this.howLong = this.lodash.find(this.prescriptionHowLongs, {
            id: this.prescriptionItemAction.howLong.id,
          });
        }
      },
      validatePrescriptionItemAction() {
        const errorMsg = "Esse campo deve ser preenchido.";
        this.errors = {};

        if (!this.actionUnity || !this.actionUnity.id) {
          this.errors.actionUnity = errorMsg;
        }
        if (!this.frequency || !this.frequency.id) {
          this.errors.frequency = errorMsg;
        }
        if (!this.howLong || !this.howLong.id) {
          this.errors.howLong = errorMsg;
        }

        if (Object.keys(this.errors).length === 0) {
          return true;
        }

        return false;
      },
      savePrescriptionItemAction() {
        if (this.disabled) return;
        if (!this.validatePrescriptionItemAction()) return;

        let periodId = "";
        if (this.period) {
          periodId = this.period.id;
        }

        this.apolloMutate({
          mutation: SAVE_PRESCRIPTION_ITEM_ACTION,
          variables: {
            prescriptionItemId: this.prescriptionItemId,
            prescriptionItemActionId: this.prescriptionItemActionId,
            actionQuantity: `${this.actionQuantity}`,
            presentationActionId: this.actionUnity.id,
            prescriptionFrequencyId: this.frequency.id,
            prescriptionPeriodId: periodId,
            prescriptionHowLongId: this.howLong.id,
          },
        }).then(({ data }) => {
          this.prescriptionItemActionId = data.savePrescriptionItemAction.id;

          if (this.prescriptionItemAction.id === "") {
            this.loadAction();
          }

          this.refreshList();
        });
      },
      deletePrescriptionItemAction() {
        if (this.disabled) return;

        this.apolloMutate({
          mutation: DELETE_PRESCRIPTION_ITEM_ACTION,
          variables: {
            prescriptionItemActionId: this.prescriptionItemActionId,
          },
        }).then(() => {
          this.refreshList();
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
